var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"top-bar__main"},[_vm._t("main")],2),_c('div',{staticClass:"top-bar__extra"},[_vm._t("extra")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }